import { Stack } from "@mui/material";
import { I18N_NAMESPACES } from "@src/appV2/i18n/constants";
import { useTu } from "@src/appV2/i18n/useTu";

import { Text } from "../../../components/Text";
import { ChildFacilitiesSelect } from "./ChildFacilitiesSelect";

interface JobManagementSectionViewProps {
  showChildFacilitiesSelect: boolean;
  workplaceId: string;
}

export function JobManagementSectionView({
  showChildFacilitiesSelect,
  workplaceId,
}: JobManagementSectionViewProps) {
  const { tu } = useTu(I18N_NAMESPACES.settings);

  if (!showChildFacilitiesSelect) {
    return (
      <Text color="text.secondary" variant="body2">
        {tu("No job management settings are available for this workplace.")}
      </Text>
    );
  }

  return (
    <Stack>
      <ChildFacilitiesSelect workplaceId={workplaceId} />
    </Stack>
  );
}
